import { Button } from "antd";
import { useTranslation } from "react-i18next";

const CallbackButton = ({ onCallBackClick }) => {
  const { t } = useTranslation();

  return (
    <div className="mx-5">
      <Button
        onClick={onCallBackClick}
        className="primary-button-large justify-center items-center"
        block
      >
        {`${t("payment.return")} ${t("my-firouzeh")}`}
      </Button>
    </div>
  );
};
export default CallbackButton;
